<template>
  <div>
    <HeaderNavbar :title="$t('billing.splits.title')" :breadcrumbs="listBreadcrumbs" />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import HeaderNavbar from '@/components/header/HeaderNavbar.vue';
import translator from '@/locale/translator';

const listBreadcrumbs = computed(() => [
  { label: translator.get('nav.billing'), path: { name: 'billing' } },
  { label: translator.get('nav.billing.budget'), path: { name: 'billing.budget' } },
  { label: translator.get('nav.billing.budget.splits'), path: { name: 'billing.splits' } },
]);
</script>
